@if (images().length > 0) {
  <span>{{ "projectDetails.gallery.title" | translate }}</span>
  <app-img-gallery
    [images]="images()"
    [perRow]="perRow"
    [maxToDisplayAmount]="7"
  />
} @else {
  <span>{{ "projectDetails.gallery.noImages" | translate }}</span>
}
